import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { QuestionDisplayLogicDrawer } from '../pages/logic-and-layout/QuestionDisplayLogicDrawer';
import { IQuestionListRowProps, QuestionRow } from './QuestionRow';

export const SurveyQuestionTableRow = styled.div.attrs({
	className: 'tws-formatted-table-row',
})`
	margin-bottom: 10px;
	margin-right: 0px;
	min-width: 500px;
	position: relative;

	display: flex;

	> :first-child {
		background-color: ${globalVars.tertiaryBlue2};
		border-bottom-left-radius: 4px;
		border-top-left-radius: 4px;
		padding: 0px;
		color: ${globalVars.white};
		display: flex;
		display: -ms-flexbox;
		display: -webkit-flex;
		align-items: center;
		justify-content: center;
		flex: 1 1 0%;
		-webkit-flex: 1 1 0%;
		-ms-flex: 1 1 0%;
		word-break: unset;
		min-width: 30px;
		width: 30px;
	}

	> :nth-child(2) {
		padding-left: 30px !important;
	}
`;
SurveyQuestionTableRow.displayName = 'SurveyQuestionTableRow';

export const SurveyQuestionRow = (props: IQuestionListRowProps) => {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const { question } = props;

	return (
		<>
			<SurveyQuestionTableRow>
				<QuestionRow {...props} showBranching={isDrawerOpen} ToggleDisplayLogic={toggleDrawer} />
			</SurveyQuestionTableRow>
			{question.displayRulesCount > 0 && isDrawerOpen && <QuestionDisplayLogicDrawer surveyQuestionId={question.surveyQuestionId || 0} />}
		</>
	);

	function toggleDrawer() {
		setIsDrawerOpen(!isDrawerOpen);
	}
};
